import {observer} from 'mobx-react';
import React from 'react';
import Select from 'react-select';
import {
  ReactSelectHelper,
  ReactSelectOnChangeCallback
} from '../../../../../../lib/components/select/base/react-select-types';
import {GapFillingBehavior, GapFillingBehaviorLabels} from '../../models';
import {GapFillingEditStore} from '../GapFillingEditStore';

type BehaviorSelectProps = {
  value: GapFillingBehavior;
  onChange: (leftSide: GapFillingBehavior) => void;
};

type OptionType = { value: GapFillingBehavior, label: string };

const options: readonly OptionType[] = [
  {value: 'drag-and-drop', label: GapFillingBehaviorLabels['drag-and-drop']},
  {value: 'keyboard-type', label: GapFillingBehaviorLabels['keyboard-type']}
];

class GapFillingBehaviorSelector extends React.Component<BehaviorSelectProps> {
  constructor(props: Readonly<BehaviorSelectProps>) {
    super(props);
    this.handleChange = ReactSelectHelper.mappingSingle(
      'MatchingQuestionLeftType',
      (option: OptionType) => option.value,
      props.onChange);
  }

  handleChange: ReactSelectOnChangeCallback<OptionType>;

  render() {
    const value = options.find(x => x.value === this.props.value)!;

    return (
      <Select<OptionType> options={options}
                          value={value}
                          onChange={this.handleChange}
                          isClearable={false}>
      </Select>);
  }
}

const GapFillingBehaviorSelectFn: React.FC<{ store: GapFillingEditStore }> =
  (props) => {
    const store = props.store;
    return (<GapFillingBehaviorSelector value={store.behavior.value}
                                        onChange={store.behavior.setValue}/>);
  };

export const GapFillingBehaviorSelect = observer(GapFillingBehaviorSelectFn);
